import React from 'react';

const RequestSentView = ({ onOk, profile }) => {
    return (
        <div className="min-h-screen bg-white p-6 flex flex-col items-center justify-center">
            <h2 className="text-2xl font-bold mb-4">Request sent to play!</h2>
            <p className="text-gray-600 mb-8">Once {profile.name} accepts your request we will notify you.</p>
            <button
                onClick={onOk}
                className="w-full bg-gradient-to-r from-purple-600 to-pink-500 text-white rounded-full py-3 font-semibold"
            >
                OK
            </button>
        </div>
    );
};

export default RequestSentView;